import type { StateCreator } from 'zustand'

import type { Theme } from '../../types/common'
import type { AllSlices } from '../types'
import type { CommonSlice } from '../types/common'

export const createCommonSlice: StateCreator<
  AllSlices,
  [],
  [],
  CommonSlice
> = set => ({
  isChatVisible: false,
  casinoTheme: localStorage.getItem('casinoTheme')
    ? (localStorage.getItem('casinoTheme') as Theme)
    : 'dark',
  sportsTheme: localStorage.getItem('sportsTheme')
    ? (localStorage.getItem('sportsTheme') as Theme)
    : 'light',
  themeSponsors: localStorage.getItem('sponsorsTheme')
    ? (localStorage.getItem('sponsorsTheme') as Theme)
    : 'light',
  theme: localStorage.getItem('casinoTheme')
    ? (localStorage.getItem('casinoTheme') as Theme)
    : 'dark',
  isTopAdVisible: true,
  isDownloadPwaVisible: false,
  isPendingDepositVisible: false,
  isCoinAnimVisible: false,
  isFullScreen: false,
  isDownloadVisible: true,
  footerLinks: {},
  isFloatingButtonsCollapsed: true,
  setIsCoinAnimVisible: isVisible => {
    set(state => ({
      common: { ...state.common, isCoinAnimVisible: isVisible },
    }))
    if (isVisible) {
      setTimeout(
        () =>
          set(state => ({
            common: { ...state.common, isCoinAnimVisible: false },
          })),
        3000,
      )
    }
  },
  setIsChatVisible: isVisible =>
    set(state => ({ common: { ...state.common, isChatVisible: isVisible } })),
  setCasinoTheme: (theme: Theme) =>
    set(state => ({
      common: {
        ...state.common,
        casinoTheme: theme,
        ...(!window.location.pathname.startsWith('/sports') &&
          !window.location.pathname.startsWith('/sponsors') && { theme }),
      },
    })),
  setSportsTheme: (theme: Theme) =>
    set(state => ({
      common: {
        ...state.common,
        sportsTheme: theme,
        ...(window.location.pathname.startsWith('/sports') && { theme }),
      },
    })),
  setThemeSponsors: (theme: Theme) =>
    set(state => ({
      common: {
        ...state.common,
        themeSponsors: theme,
        ...(window.location.pathname.startsWith('/sponsors') && { theme }),
      },
    })),
  setIsTopAdVisible: isVisible =>
    set(state => ({ common: { ...state.common, isTopAdVisible: isVisible } })),
  setIsDownloadPwaVisible: isVisible =>
    set(state => ({
      common: { ...state.common, isDownloadPwaVisible: isVisible },
    })),
  setIsPendingDepositVisible: isVisible =>
    set(state => ({
      common: { ...state.common, isPendingDepositVisible: isVisible },
    })),
  setIsFullScreen: isFullScreen =>
    set(state => ({
      common: { ...state.common, isFullScreen: isFullScreen },
    })),
  setIsDownloadVisible: isVisible =>
    set(state => ({
      common: { ...state.common, isDownloadVisible: isVisible },
    })),
  setFooterLinks: footerLinks =>
    set(state => ({
      common: { ...state.common, footerLinks },
    })),
  setIsFloatingButtonsCollapsed: isCollapsed =>
    set(state => ({
      common: { ...state.common, isFloatingButtonsCollapsed: isCollapsed },
    })),
})
